
import React, { useState } from 'react';
import { LimsModule } from '../components/LimsModule';
import { LabTestRequest, LabRig, LabSample, LabRequestStatus, RigStatus } from '../types';

// LIMS Mocks
const INITIAL_REQUESTS: LabTestRequest[] = [
    {
        id: 'LR-2025-001',
        projectCode: 'PRJ-2025-A',
        customer: 'Automotive OEM A',
        partDetails: { name: 'ECU-Main-Board', batch: 'B2025-01', dateCode: '2501', qty: 10 },
        testName: 'Thermal Cycle - Profile A',
        requestor: 'J. Smith',
        priority: 'Normal',
        status: LabRequestStatus.IN_PROGRESS,
        requestDate: '2025-02-10',
        dueDate: '2025-02-25',
        samples: ['S-104', 'S-105'],
        assignedRigId: 'RIG-001',
        testParameters: { tempLow: -40, tempHigh: 85, cycles: 500 },
        qcGates: { calibrationChecked: true, samplesVerified: true, environmentChecked: false }
    },
    {
        id: 'LR-2025-002',
        projectCode: 'PRJ-2025-B',
        customer: 'Energy Systems Inc.',
        partDetails: { name: 'Inv-Power-Mod', batch: 'B2025-02', dateCode: '2502', qty: 6 },
        testName: 'Vibration - Random Z-Axis',
        requestor: 'M. Garcia',
        priority: 'High',
        status: LabRequestStatus.SUBMITTED,
        requestDate: '2025-02-12',
        dueDate: '2025-02-15',
        samples: ['S-201', 'S-202'],
        testParameters: { axis: 'Z', duration: 24 },
        qcGates: { calibrationChecked: false, samplesVerified: false, environmentChecked: false }
    },
    {
        id: 'LR-2025-003',
        projectCode: 'PRJ-2025-C',
        customer: 'Tier 1 Supplier',
        partDetails: { name: 'Conn-Housing-Main', batch: 'B2025-03', dateCode: '2503', qty: 12 },
        testName: 'Salt Fog Exposure',
        requestor: 'A. Chen',
        priority: 'Normal',
        status: LabRequestStatus.APPROVED,
        requestDate: '2025-02-11',
        dueDate: '2025-03-01',
        samples: ['S-301'],
        testParameters: { duration: 96, temp: 35 },
        qcGates: { calibrationChecked: false, samplesVerified: false, environmentChecked: false }
    }
];

const INITIAL_RIGS: LabRig[] = [
    { id: 'RIG-001', name: 'Thermal Chamber A', type: 'Environmental Chamber', status: RigStatus.IN_USE, calibrationDue: '2025-06-15', location: 'Lab 1 - Row A', currentTestId: 'LR-2025-001' },
    { id: 'RIG-002', name: 'Vibration Table 1', type: 'Shaker Table', status: RigStatus.AVAILABLE, calibrationDue: '2025-03-01', location: 'Lab 2 - Bay 1' },
    { id: 'RIG-003', name: 'Oven B', type: 'High Temp Oven', status: RigStatus.AVAILABLE, calibrationDue: '2024-12-01', location: 'Lab 1 - Row B' }, // Overdue
    { id: 'RIG-004', name: 'Drop Tower', type: 'Mechanical', status: RigStatus.MAINTENANCE, calibrationDue: '2025-08-20', location: 'Lab 3' },
];

const INITIAL_SAMPLES: LabSample[] = [
    { id: 'S-104', name: 'ECU Rev 2', batch: 'B2025-01', status: 'In Testing', location: 'RIG-001' },
    { id: 'S-201', name: 'Connector Housing', batch: 'B2025-02', status: 'Received', location: 'Storage A' },
];

const LimsPage: React.FC = () => {
    const [labRequests, setLabRequests] = useState<LabTestRequest[]>(INITIAL_REQUESTS);
    const [labRigs, setLabRigs] = useState<LabRig[]>(INITIAL_RIGS);
    const [labSamples, setLabSamples] = useState<LabSample[]>(INITIAL_SAMPLES);

    return (
        <div className="flex-1 h-full bg-slate-50 overflow-hidden">
            <LimsModule
                requests={labRequests}
                setRequests={setLabRequests}
                rigs={labRigs}
                setRigs={setLabRigs}
                samples={labSamples}
                setSamples={setLabSamples}
            />
        </div>
    );
};

export default LimsPage;
